//@Phillip for loadouts to be typed I need to have a default state to reset a nested object of our session to..
//I am not sure the best way to approach my problem here so if ya have a minute to chat when reading this ping me!

import { TLoadout, TSequence } from "../@types";

export const DEFAULT_LOADOUT: TLoadout = {
  name: "",
  description: "",
  image: "",
  hoverEffectSrc: "",
  hoverEffect: "",
  displayCards: [],
  cards: [],
  badge: "",
};

export const DEFAULT_SEQUENCE: TSequence = {
  sequenceType: "",
  description: "",
  image: "",
  requires: [],
  video: "",
  qualify: "",
  buildDoc: {
    amsTiming: 0,
    minKills: 0,
    maxKills: 0,
  },
  comingSoon: false,
};

export const FREEFORM_SEQUENCE: TSequence = {
  sequenceType: "Freeform",
  description:
    "Create your own from your available clips. Meet the requirements and you're set.",
  image: "static/sequences/Freeform.webp",
  requires: [
    {
      text: "10 to 20 kills",
      icon: '<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4.08301 11.7669L6.41634 2.43359M7.58301 11.7669L9.91634 2.43359M3.49967 5.35026H11.6663M2.33301 8.85026H10.4997" stroke="#71AAFF" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    },
    {
      text: "6+ Clips",
      icon: '<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4.08333 2.43359V11.7669M9.91667 2.43359V11.7669M1.75 4.76693H4.08333M9.91667 4.76693H12.25M1.75 7.10026H12.25M1.75 9.43359H4.08333M9.91667 9.43359H12.25M2.33333 11.7669H11.6667C11.8214 11.7669 11.9697 11.7055 12.0791 11.5961C12.1885 11.4867 12.25 11.3383 12.25 11.1836V3.01693C12.25 2.86222 12.1885 2.71384 12.0791 2.60445C11.9697 2.49505 11.8214 2.43359 11.6667 2.43359H2.33333C2.17862 2.43359 2.03025 2.49505 1.92085 2.60445C1.81146 2.71384 1.75 2.86222 1.75 3.01693V11.1836C1.75 11.3383 1.81146 11.4867 1.92085 11.5961C2.03025 11.7055 2.17862 11.7669 2.33333 11.7669Z" stroke="#71AAFF" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    },
    {
      text: "2k +",
      icon: '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6 1.6414C6.31351 1.28597 6.72781 1.03444 7.18779 0.920275C7.64777 0.806109 8.1316 0.834718 8.57492 1.0023C9.01824 1.16988 9.40001 1.46848 9.66945 1.85837C9.93889 2.24827 10.0832 2.71096 10.0832 3.1849C10.0832 3.65883 9.93889 4.12153 9.66945 4.51142C9.40001 4.90131 9.01824 5.19992 8.57492 5.3675C8.1316 5.53507 7.64777 5.56368 7.18779 5.44952C6.72781 5.33535 6.31351 5.08382 6 4.7284M7.75 11.3516H0.75V10.7682C0.75 9.83997 1.11875 8.94973 1.77513 8.29336C2.4315 7.63698 3.32174 7.26823 4.25 7.26823C5.17826 7.26823 6.0685 7.63698 6.72487 8.29336C7.38125 8.94973 7.75 9.83997 7.75 10.7682V11.3516ZM7.75 11.3516H11.25V10.7682C11.2501 10.1538 11.0884 9.55019 10.7813 9.01806C10.4741 8.48592 10.0323 8.04402 9.50021 7.73677C8.96813 7.42952 8.36454 7.26776 7.75012 7.26773C7.1357 7.26771 6.5321 7.42944 6 7.73665M6.58333 3.1849C6.58333 3.80373 6.3375 4.39723 5.89992 4.83481C5.46233 5.2724 4.86884 5.51823 4.25 5.51823C3.63116 5.51823 3.03767 5.2724 2.60008 4.83481C2.1625 4.39723 1.91667 3.80373 1.91667 3.1849C1.91667 2.56606 2.1625 1.97257 2.60008 1.53498C3.03767 1.0974 3.63116 0.851563 4.25 0.851563C4.86884 0.851563 5.46233 1.0974 5.89992 1.53498C6.3375 1.97257 6.58333 2.56606 6.58333 3.1849Z" stroke="#71AAFF" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    },
  ],
  video: "static/sequences/FreeFormSequence.mp4",
  qualify: "freeform",
  buildDoc: {
    amsTiming: 1,
    minKills: 10,
    maxKills: 20,
  },
  comingSoon: false,
};
